import {
  setClearGraphData,
  setClearProfileFiltersPanes,
  setGlobalFilter,
  setPaneBrands,
} from "./dashboard/Tab1";
import { setWidgetLoader } from "./ApiCall/apiCall";
import { setOptionHighChart } from "./HighChart";

export const setSelectCategoryValue = (value) => {
  return { type: "SET_CATEGORY_VALUE", payload: value };
};

export const setSelectBrandValue = (value) => {
  return { type: "SET_BRAND_VALUE", payload: value };
};

export const setSelectProfileId = (value) => {
  return { type: "SET_PROFILE_ID", payload: value };
};
export const setChannelImage = (value) => {
  return { type: "SET_CHANNEL_IMAGE", payload: value };
};

export const setProfileImage = (value) => {
  return { type: "SET_PROFILE_IMAGE", payload: value };
};

export const setBrandCheckedItems = (value) => {
  return { type: "SET_BRAND_CHECKED_ITEMS", payload: value };
};

const defaultBrandState = (brands, defaultValue, Allbrands) => {
  let check = defaultValue
    ? {
        [brands && brands[0]?.brand_friendly_name]: true,
      }
    : {};
  let myArr = [];
  if (brands?.length > 0) {
    brands &&
      brands?.map((el, i) => {
        myArr.push({
          name: el?.brand_id ? el?.brand_id : el?.name,
          type: "include",
          brand_friendly_name: el?.brand_friendly_name,
        });
        return (check = { ...check, [el?.brand_friendly_name]: true });
      });
  } else {
    let brand = [brands];
    brand &&
      brand?.map((el, i) => {
        myArr.push({
          name: el?.brand_id ? el?.brand_id : el?.name,
          type: "include",
          brand_friendly_name: el?.brand_friendly_name,
        });
        return (check = { ...check, [el?.brand_friendly_name]: true });
      });
  }

  return {
    check: check,
    myArr: myArr,
  };
};

export const setGlobalBrandValue = (brandsObject) => {
  let updateselectValue = { ...brandsObject?.selectBrandValue };
  let updatecheckedValue = { ...brandsObject?.brandCheckedItems };

  if (brandsObject?.value) {
    let obj = defaultBrandState(
      brandsObject?.value[0]?.columns,
      false,
      brandsObject?.brands
    );
    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  } else {
    let obj = defaultBrandState(brandsObject?.brands, true);
    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  }

  return (dispatch) => {
    dispatch({ type: "SET_BRAND_VALUE", payload: updateselectValue });
    dispatch({ type: "SET_BRAND_CHECKED_ITEMS", payload: updatecheckedValue });
  };
};

export const setSectionBrandValue = (brandsObject) => {
  let updateselectValue = { ...brandsObject?.selectBrandValue };
  let updatecheckedValue = { ...brandsObject?.brandCheckedItems };

  if (brandsObject?.value) {
    let obj = defaultBrandState(
      brandsObject?.value[0]?.columns,
      false,
      brandsObject?.brands
    );
    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  } else {
    let obj = defaultBrandState(brandsObject?.brands, true);
    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  }

  return (dispatch) => {
    dispatch({ type: "SET_BRAND_VALUE", payload: updateselectValue });
    dispatch({ type: "SET_BRAND_CHECKED_ITEMS", payload: updatecheckedValue });
  };
};

export const setWidgetBrandValue = (brandsObject) => {
  let updateselectValue = { ...brandsObject?.selectBrandValue };
  let updatecheckedValue = { ...brandsObject?.brandCheckedItems };

  if (brandsObject?.value) {
    let obj = defaultBrandState(
      brandsObject?.value[0]?.columns,
      false,
      brandsObject?.brands
    );
    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  } else {
    let obj = defaultBrandState(brandsObject?.brands, true);
    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  }

  return (dispatch) => {
    dispatch({ type: "SET_BRAND_VALUE", payload: updateselectValue });
    dispatch({ type: "SET_BRAND_CHECKED_ITEMS", payload: updatecheckedValue });
  };
};
export const setGraphPageBrandValue = (brandsObject) => {
  let updateselectValue = { ...brandsObject?.selectBrandValue };
  let updatecheckedValue = { ...brandsObject?.brandCheckedItems };

  if (brandsObject?.value) {
    let obj = defaultBrandState(
      brandsObject?.value,
      false,
      brandsObject?.brands
    );
    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  } else {
    let obj = defaultBrandState(brandsObject?.brands, true);
    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  }

  return (dispatch) => {
    dispatch({ type: "SET_BRAND_VALUE", payload: updateselectValue });
    dispatch({ type: "SET_BRAND_CHECKED_ITEMS", payload: updatecheckedValue });
  };
};

export const setCategoryCheckedItems = (value) => {
  return { type: "SET_CATEGORY_CHECKED_ITEMS", payload: value };
};

export const setCategoryFlag = (value) => {
  return { type: "SET_CATEGORY_FLAG", payload: value };
};

export const setBrandFlag = (value) => {
  return { type: "SET_BRAND_FLAG", payload: value };
};

export const setBrandActiveKey = (value) => {
  return { type: "SET_BRAND_ACTIVE_KEY", payload: value };
};

export const setCategoryActiveKey = (value) => {
  return { type: "SET_CATEGORY_ACTIVE_KEY", payload: value };
};

export const setOpenPre = (value) => {
  return { type: "SET_PRE_CRISIS_DATE", payload: value };
};
export const setOpenDuring = (value) => {
  return { type: "SET_DURING_CRISIS_DATE", payload: value };
};
export const setOpenPost = (value) => {
  return { type: "SET_POST_CRISIS_DATE", payload: value };
};
export const updateDashboardBrands = (paneObj) => {
  return (dispatch) => {
    dispatch(setPaneBrands(paneObj, "global_dashboard"));

    (paneObj?.selectBrands?.columns?.length > 0 ||
      paneObj?.selectBrands?.columns?.brand_id) &&
      dispatch(
        setClearGraphData(paneObj?.index, paneObj?.panes, "global_brands")
      );

    // Clear profile_filters of all widgets on change of global brands
    dispatch(setClearProfileFiltersPanes(paneObj?.index, paneObj?.panes));

    dispatch(setGlobalFilter(null, paneObj?.index, paneObj?.panes, paneObj));
    // dispatch(setOptionHighChart(null));
  };
};

export const setDashboardBrandObj = (paneObj) => {
  return (dispatch) => {
    dispatch({ type: "DASHBOARD_BRAND_FFILTER_OBJ", payload: paneObj });
  };
};

export const setTemplateBrandObj = (paneObj) => {
  return (dispatch) => {
    dispatch({ type: "TEMPLATE_BRAND_FFILTER_OBJ", payload: paneObj });
  };
};

export const setClearBrandAndDuration = (paneObj) => {
  return (dispatch) => {
    dispatch({ type: "SET_CLEAR_BRAND_AND_DURATION", payload: paneObj });
  };
};

export const setDashboardProfileFilterObj = (paneObj) => {
  return (dispatch) => {
    dispatch({ type: "DASHBOARD_PROFILE_FILTER_OBJ", payload: paneObj });
  };
};
export const setCompetitorBrandType = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_COMPETITOR_BRAND_TYPE", payload: value });
  };
};
